<template>
<div>

  <div class="content content-boxed">

    <div class="row">
      <div class="col-xs-12">
        <div class="block block-rounded">
          <div class="block-header">
            <h2 class="block-title">{{ labelTopDatePicker[actualLanguage] }}</h2>
          </div>
          <div class="block-content">
            <range-picker @refresh="refreshData"></range-picker>
          </div>
        </div>
      </div>
    </div>

    <div v-if="displayAlertTronquedResults" class="row">
      <div class="col-xs-12">
        <div class="block block-rounded">

          <div class="col-lg-12">
              <a class="block block-link-hover2" >
                  <div class="block-content block-content-full bg-city clearfix">
                      <i class="fa fa-exclamation-triangle fa-2x text-white pull-left"></i>
                      <span class="h4 font-w700 text-white">{{alertTronquedResultMessage[actualLanguage]}}</span>
                  </div>
              </a>
          </div>

        </div>
      </div>
    </div>


    <!-- Enregistrement de plan pré-enregistré -->
    <div class="block block-themed">
      <div class="block-header bg-primary-dark">
            <ul  class="block-options">
                <li v-if="flagDisplayAddService===0">
                    <button type="button" @click="toggleDisplayAddService()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                </li>
                <li v-if="flagDisplayAddService">
                    <button  type="button" @click="toggleDisplayAddService()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                </li>
            </ul>
        <h2 class="block-title" @click="toggleDisplayAddService()">{{labelAlertList[actualLanguage]}}</h2>
      </div>

      <div v-if="flagDisplayAddService" class="block-content">

        <div class="row">
          <div class="col-xs-12">
              <div v-if="loadingAlertData ">
                <spinner :message=labelSpinner[actualLanguage]></spinner>
              </div>
              <div v-else>

                <dynamic-table :tableDataObj="tableData"></dynamic-table>
              </div>
          </div>
        </div>

      </div>
    </div>
    <!-- END Enregistrement de plan pré-enregistré -->


  </div>
</div>



</template>


<script>

import Spinner from '@/components/Spinner'
import DynamicTable from '@/components/DynamicDataTable1'
import RangePicker from '@/components/RangePicker'


import {mapState, mapActions, mapGetters} from 'vuex'
import _ from 'underscore'

export default {
  name: 'AlertIndex',

  data() {
    return {
      isOpen : true,
      loadingAlertData : false,
      displayAlertTronquedResults : false,
      dataTempo01 : 'test',
      dataTempo02 : 'test',
      flagDisplayAddService : -1,
      displayMessage : '--',
      moduleBindingData : '',
      codeConfirmed : false,
      transmitDataModel: {
        deviceId: '',
        deviceKey: '',
      },
      tableData: {
        tableTitle: [ {FR: 'Moment', EN: 'Time'},
                      {FR: 'Appareil', EN: 'Device'},
                      {FR: 'Port', EN: 'Port'},
                      {FR: 'Nom du port', EN: 'Port name'},
                      {FR: "Type d'alerte", EN: 'Alert type'},
                      {FR: "Message de l'alerte", EN: 'Alert message'},
                      ],
        tableData: [
                      ['', '', '','','','']
    ],
        flagDisplayHistogramSection: true,
      },
      eventLogData : [],
      labelTopDatePicker: {FR: 'Plage à observer', EN: 'Period selector'},
      labelAlertList: {FR: 'Liste des alertes', EN: 'Alert list'},
      labelSpinner: {FR: 'Téléchargement des données', EN: 'Data transfer'},
      alertTronquedResultMessage: {FR: 'Il peut manquer des alertes dans la liste, la plage de temps est trop grande.', EN: 'Alerts may be missing from the list, time range is too large. '},
      actualLanguage : "FR",
    }
  },

  components: {
    Spinner,
    DynamicTable,
    RangePicker,
  },

  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','planTransactionData']),
    ...mapState('chargesStore',['startDate', 'endDate']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayAddService(){
      this.flagDisplayAddService = ~this.flagDisplayAddService
    },


    readAlertsHistory(dates) {
        this.loadingAlertData = true;
        return this.$store.dispatch('sessionStore/getAlertsHistory',dates)
        .then((response) => {
          //console.log(response.data);
          this.displayAlertTronquedResults = false;
          this.tableData.tableData = [];
          for (let i = 0;i < response.data.AlertData.length;i++){
            this.tableData.tableData.push(
              [
                response.data.AlertData[i].timestamp,
                response.data.AlertData[i].device_id,
                response.data.AlertData[i].port_id,
                response.data.AlertData[i].port_name,
                response.data.AlertData[i].alert_title,
                response.data.AlertData[i].message
              ]
            )
            response.data.AlertData[i].timestamp
          }




          if (response.data.LimitReached){this.displayAlertTronquedResults = true;}

          this.loadingAlertData = false;
          })
    },

 
    refreshData(dates) {
      //console.log(dates)
      this.$store.dispatch('chargesStore/setStartDate', dates.startDate)
      this.$store.dispatch('chargesStore/setEndDate', dates.endDate)
      this.readAlertsHistory(dates)
    },


    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// Index.vue?06eea867